"use client";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const DifferentiationSection = () => {
  const { t } = useTranslation();
  const backupPoints = t("differentiation.comparison.backup.points", { returnObjects: true }) as string[];
  const resiliencePoints = t("differentiation.comparison.resilience.points", { returnObjects: true }) as string[];

  return (
    <section id="differentiation" className="py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mx-auto text-center"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-6">
            {t("differentiation.title")}{" "}
            <span className="text-primary">{t("differentiation.titleHighlight")}</span>
          </h2>
          <p className="text-foreground text-xl font-medium leading-snug mb-4">
            {t("differentiation.statement")}
          </p>
          <p className="text-muted-foreground text-lg leading-relaxed">
            {t("differentiation.description")}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-12 grid md:grid-cols-2 gap-6 max-w-4xl mx-auto"
        >
          <div className="rounded-xl border border-border bg-secondary/40 p-6">
            <h3 className="font-display text-lg font-semibold text-foreground mb-4">
              {t("differentiation.comparison.backup.title")}
            </h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {backupPoints.map((point, i) => (
                <li key={i}>- {point}</li>
              ))}
            </ul>
          </div>
          <div className="rounded-xl border border-primary/30 bg-primary/5 p-6">
            <h3 className="font-display text-lg font-semibold text-foreground mb-4">
              {t("differentiation.comparison.resilience.title")}
            </h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {resiliencePoints.map((point, i) => (
                <li key={i}>- {point}</li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DifferentiationSection;
